import { TranslationsNamespaces } from '../constants/TranslationsNamespaces';

export const namespaces = [
    TranslationsNamespaces.LOGIN,
    TranslationsNamespaces.PROFILE,
];
